<template>
	<Sprite />
	<Header />
	<div style="display: none">
		<h1>Welwin | Welwin</h1>
		<p>Самые прибыльные и интересные игры <b>Welwin онлайн</b> представлены на данном официальном сайте.
		</p>
		<p>Лучшие возможности для игры на официальном сайте Welwin лицензионные игры, бонусы и быстрые
			платежные методы для всех игроков.</p>
		<h2>Welwin промокод</h2>
		<p>Играть на нашем сайте Welwin - просто и прибыльно! </p>
		<p>Платежная система выбирается, учитывая интересы региона и персональных желаний потенциальных
			клиентов. Главными критериями отбора являются удобство и безопасность. Главным достоинством
			большинства казино является наличие большого количества платежных систем, что позволяет каждому
			посетителю выбрать способ оплаты, наиболее удобный для него.</p>
		<p>Играть онлайн пользователь может без депозита своих средств в игру <b>Welwin</b> онлайн это
			значит, что бонусы не требуют обязательного пополнения счета. Мы гарантируем честную игру,
			большие промокоды и быстрый вывод средств. Участвуйте в чемпионатах и лотереях, забирайте
			промокоды за активную игру. Все онлайн игры предоставлены на нашем официальном сайте без
			изменения функционала, каждую игру проверяйте на честность.</p>
		<h3>Мобильная версия</h3>
		<p>Тут уже готово все: лицензия, домен, технической обеспечение, контент, платежные системы и так
			далее. Это требует минимальных затрат в плане времени и финансов, что является несомненным
			плюсом. Однако заказчик в этом случае не сможет самостоятельно принимать все решения, касающиеся
			казино. И тут уже каждый сам выбирает что ему важнее: минимальные затраты или возможность
			самостоятельно принимать решения.</p>
		<p>Компания предлагает качественную техническую поддержку. Бесперебойная система, работающая
			ежедневно и круглосуточно, а также компетентные сотрудники понравятся игрокам. Каждый клиент
			может задать службе поддержки любой интересующий его вопрос и получить на него ответ.</p>
		<h4>Welwin бонус</h4>
		<p>Суммы призов также варьируются – от небольших утешительных призов, до действительно солидных
			денежных вознаграждений. Всё зависит только от удачи, от того, насколько она благосклонна
			сегодня к конкретному игроку. Вывести свой приз можно в любое время – достаточно заглянуть в
			личный кабинет и заказать выплату средств.</p>
		<p>Если казино имеет лицензию, то это гарантия законности его деятельности, что является необходимым
			условием для привлечения пользователей. Также оно получает возможность работать с различными
			платежными системами и популярными разработчиками программного обеспечения. Вариант
			лицензирования является оптимальным для региона, в котором проживает заказчик. Клиенту также
			предоставляется консультация по юридическим вопросам, интересующим его.</p>
		<p>
			Компания предоставляет заказчику специальное программное обеспечение, позволяющее осуществлять
			управление финансами, безопасностью и контентом. Также происходит разработка и отладка функций,
			дизайна и так далее. Сделать это самостоятельно было бы гораздо труднее.
		</p>
	</div>
	<main class="layout">
		<UserMenu class="layout__user-menu" v-if="user !== null && isTablet" />
		<SignIn v-if="user === null && isTablet" class="fields__item" />
		<div v-if="!isTablet" class="layout__aside">
			<UserMenu class="layout__user-menu" v-if="user !== null" />
			<SignIn v-if="user === null" />
			<Sidebar class="layout__sidebar" />
			<HistorySlots class="layout__slots-history" />

		</div>
		<Loader class="layout__loader" id="loadPage" :loading="$root.isLoading" v-show="$root.isLoading" />

		<div class="layout__body" v-show="!$root.isLoading">
			<router-view v-slot="{ Component }">
				<transition name="fade" mode="out-in">
					<component :is="Component" />
				</transition>
			</router-view>
		</div>

		<div v-if="user !== null && user.ban" class="alert alert--danger" role="alert">
			Ваш аккаунт заблокирован. Причина: {{ user.ban_reason ? user.ban_reason : 'не указана' }}
		</div>


	</main>
	<Deposit v-if="user !== null" />
	<PinModal v-if="user !== null" />

	<Footer />

	<div v-if="this.user && this.user.impersonate" class="impersonate">
		<a :href="user.impersonate" class="btn btn--primary impersonate__btn">
			Нажмите сюда, чтобы снова авторизоваться в своём аккаунте
		</a>
	</div>

	<Notification />
</template>

<script>
	import { useUserStore } from '../stores/User';
	import {mapState} from "pinia";
    import Header from "./Header/Header.vue";
    import Footer from "./Footer/Footer.vue";
    import SignIn from "./Modals/SignIn.vue";
    import UserMenu from "./Modals/UserMenu.vue";
    import PinModal from "./Modals/Pin.vue";
    import Deposit from "./Modals/Deposit.vue";
    import HistorySlots from "./History/Slots.vue";
    import Notification from "./Notification/Notification.vue";
	import Sprite from "./Sprite.vue";
	import BreakpointsMixin from "../mixins/breakpoints-mixin.vue";
	import Loader from "./blocks/Loader.vue";
	import Sidebar from "./Navigation/Sidebar.vue";

    export default {
        components: {
			Sidebar,
			Sprite,
            Header,
            SignIn,
            UserMenu,
            PinModal,
            Deposit,
            HistorySlots,
            Footer,
            Notification,
			Loader
        },
		mixins: [
			BreakpointsMixin
		],
        data() {
            return {

            }
        },
		computed: {
			...mapState(useUserStore, ['user']),

			page() {
				return this.$route.name;
			}
		}
    }
</script>
